import { createStore } from 'vuex'
import emergency from './modules/emergency'
import ecological from './modules/ecological'

export default createStore({
  modules: {
    emergency,
    ecological
  },
  strict: process.env.NODE_ENV !== 'production'
})